import endpoint from '../endpoint/endpoint.ts'

export default {
  install: (app) => {
    app.config.globalProperties.$endpoint = endpoint;
  },
};
